var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    className: "nd-icon nd-stackItem__graphic im-searchOptionsListItem__icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "option-zones",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMinYMid"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillOpacity: 0.3,
    d: "M9.25 2.385v8.925h4.875l5.587-5.653A9.955 9.955 0 0 0 12 2c-.954 0-1.876.134-2.75.385Zm5.905 8.925 5.016-5.048a10.052 10.052 0 0 1 1.801 5.048h-6.817Zm-1.12 4.744.027 5.732A9.984 9.984 0 0 1 12 22C6.477 22 2 17.494 2 11.935h7.942l4.093 4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillOpacity: 0.3,
    d: "M14.813 21.727C18.965 20.504 22 16.64 22 12.065H11.03l3.783 3.807v5.855ZM8.5 2.503a10.064 10.064 0 0 0-6.472 8.677H8.5V2.503Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.31h4.875l5.587-5.653A9.955 9.955 0 0 0 12 2c-.954 0-1.876.134-2.75.385v8.925Zm.682-.681V2.91a9.29 9.29 0 0 1 8.849 2.716l-4.94 5H9.938Zm.01 1.3H2c0 .23.008.455.023.681C2.37 17.857 6.705 22 12 22c.707 0 1.397-.074 2.063-.214l-.028-5.732-4.093-4.12Zm3.412 4.401-3.696-3.72H2.706c.347 4.868 4.38 8.702 9.294 8.702.469 0 .929-.035 1.378-.102l-.024-4.88Zm2.14 5.162a9.71 9.71 0 0 1-.681.228V15.87l-3.783-3.806H22a10.064 10.064 0 0 1-6.506 9.434Zm0-.732a9.385 9.385 0 0 0 5.8-8.02h-8.625l2.627 2.645c.127.127.198.3.198.48v4.895Zm6.478-9.457a10.044 10.044 0 0 0-1.801-5.049l-5.016 5.048h6.817Zm-5.178-.68h4.416a9.36 9.36 0 0 0-1.155-3.285l-3.261 3.284Zm-8.976-7.84c.223-.105.45-.2.682-.288v8.677H2.028a10.07 10.07 0 0 1 5.79-8.39Zm0 .756a9.39 9.39 0 0 0-5.028 6.951h5.028V3.547Z"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    className: "nd-icon__use",
    xlinkHref: "#option-zones",
    fill: "#0074C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMap);
export default __webpack_public_path__ + "static/media/open_map.67a022805b9c055b62dd67c72dd19e95.svg";
export { ForwardRef as ReactComponent };